import React from "react";
import {MenuItem, InputLabel, Select} from "@mui/material";
import Grid from '@mui/material/Grid';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    selected: {
        backgroundColor: 'rgba(197, 248, 211, 1) !important',
    }
});
export default (data, key) => {
    if(!data.renderValue) data.renderValue = (selected) => selected;
    const classes = useStyles();

    return (
        <Grid item md={12} xs={12} className={data.classList} key={key}>
            <FormControl fullWidth error={data.error ? true : false}>
                <InputLabel id={`${data.name}-${key}_label`}>
                    {data.headerName}{data?.inputProps?.required ? '*' : ''}
                </InputLabel>
                <Select
                    labelId={`${data.name}-${key}_label`}
                    fullWidth
                    multiple={data.multiple || false}
                    error={data.error ? true : false}
                    id={`${data.name}-${key}`}
                    value={data.value}
                    label={data.headerName}
                    name={data.name}
                    renderValue={data.renderValue}
                    onChange={data.onCallback}>
                    {data.items.map((val, ind) => (<MenuItem classes={{ selected: classes.selected }} key={ind} value={val}>
                        <ListItemText primary={val} />
                    </MenuItem>))}
                </Select>
                {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
            </FormControl>
        </Grid>
    )
}